export default __webpack_public_path__ + "static/media/madan.e0cc3d2c.png";